import script from "./ThePassWordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./ThePassWordReset.vue?vue&type=script&setup=true&lang=js"

import "./ThePassWordReset.vue?vue&type=style&index=0&id=44ca6b68&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44ca6b68"]])

export default __exports__